import { at } from "lodash";
import { useField } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  MarinerType,
  MarinerUnion,
  RatingTypeMap,
} from "../../common/MarinerProfile";
import { JobRating } from "../../common/JobOrder";

export default function RatingAutocompleteField(props: any) {
  const {
    name,
    typeName,
    agentUnionName,
    seniorityName,
    data,
    setFieldValue,
    getOptionLabel,
    disabled,
  } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [error] = at(meta, "error");

  const getSeniority = (typeName: MarinerType, data: any) => {
    if (typeName === MarinerType.LICENSED) {
      return "NA"
    }
    else if ([JobRating._OSA2, JobRating._OSA3, JobRating._WA2, JobRating._WA3].includes(data)) {
      return "U"
    }
    else {
      return null
    }
  }

  return (
    <Autocomplete
      options={data}
      value={!!selectedValue && selectedValue !== "" ? selectedValue : null}
      clearOnEscape={true}
      clearOnBlur={true}
      onChange={(_, value) => {
        const marinerType =
          value && RatingTypeMap.get(value)
            ? RatingTypeMap.get(value)! // can't be undefined because of the above condition
            : ""; // when cleared, set the value to empty string

        setFieldValue(typeName, marinerType);
        setFieldValue(
          agentUnionName,
          marinerType
            ? marinerType === MarinerType.LICENSED
              ? MarinerUnion.AMO
              : MarinerUnion.SIU
            : ""
        );
        setFieldValue(
          seniorityName,
          getSeniority(typeName, data)
        );
        setFieldValue(name, value);
      }}
      renderInput={(params) => <TextField {...params}  helperText={error} error={!!error} />}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={getOptionLabel}
      disabled={disabled}
    />
  );
}
